import {
  ObservabilityToolType,
  TeamExternalIntegrationAuthenticationStatus,
  type TeamExternalIntegrationGcp,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'

import type {
  AuthenticationRequestBodyGcp,
  CreateStatusCheckAuthenticationRequestParams
} from 'queries/external-integrations/types'

export const GCP_INTEGRATION_SETUP_MESSAGES = {
  errorFallback: 'Failed to fetch GCP integration setup data',
  unexpectedResponse:
    'There was an error loading the page: unexpected response for GCP integration setup data'
} as const

export function isTeamExternalIntegrationGcp(
  integration: TeamExternalIntegration
): integration is TeamExternalIntegrationGcp {
  const { identifier, integrationSpecificValues, observabilityToolType } =
    integration

  return Boolean(
    identifier &&
      observabilityToolType === ObservabilityToolType.GCP &&
      integrationSpecificValues?.serviceAccount
  )
}

export function getGcpAuthenticationPayload(
  serviceAccountId: string
): [
  CreateStatusCheckAuthenticationRequestParams,
  AuthenticationRequestBodyGcp
] {
  const observabilityToolType = ObservabilityToolType.GCP

  return [
    {
      observabilityToolType
    },
    {
      integrationSpecificValues: { serviceAccount: serviceAccountId },
      name: observabilityToolType,
      privateNetwork: false,
      lastAuthenticationStatus:
        TeamExternalIntegrationAuthenticationStatus.Authenticated
    }
  ]
}
